import * as React from "react";
import { Select } from "antd";
import { useEffect, useContext, useState, Dispatch, SetStateAction } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { ITradeOwner } from "src/services/interfaces/trade/tradeOwner/ITradeOwner";
import { PropertyRegimeEnum } from "src/services/interfaces/trade/tradeOwner/PropertyRegimeEnum";
import { IPropertyRegime } from "src/services/interfaces/trade/user-snapshot/IPropertyRegime";

interface ISelectPropertyRegime extends FormComponentProps {
  tradeOwner: ITradeOwner;
  isRegimeRequired?: boolean;
  onChange: Dispatch<SetStateAction<PropertyRegimeEnum>>;
}

export const SelectPropertyRegime: React.FC<ISelectPropertyRegime> = ({
  tradeOwner,
  onChange,
  form,
  isRegimeRequired

}) => {
  const { commonDomainService } = useContext(ServiceContext);
  const [selectList, setSelectList] = useState<IPropertyRegime[]>([]);
  useEffect(() => {
    loadPropertyRegime();
  }, []);

  function loadPropertyRegime() {
    commonDomainService.getCivilStatus().then(resp => {
      const propertyRegime = resp.civil_status_json.find(value => value.description === tradeOwner?.civilStatus)?.regimes;
      setSelectList(propertyRegime);
    });
  }

  return (
    <>
      <PbrSelect
        onChange={e => onChange(e as PropertyRegimeEnum)}
        value={tradeOwner?.propertyRegime}
        name="propertyRegime"
        placeholder={"Selecione o regime de bens"}
        size="large"
        formWrapper={form}
        formItemProps={{ label: "Regime de bens" }}
        showSearch
        rules={[{ required: isRegimeRequired, message: "Informe o regime de bens" }
        ]}
      >
        <Select.Option disabled key={"0"} value={null}>
          {"Selecione o regime de bens"}
        </Select.Option>
        {selectList.map((e, i) => (
          <Select.Option key={(i + 1).toString()} value={e.code_regime}>
            {e.description}
          </Select.Option>
        ))}
      </PbrSelect>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/CivilStatus/SelectPropertyRegime.tsx